import {useEffect, useState} from 'react';
import {useParams, Link, useHistory} from 'react-router-dom';
import {
  Button,
  Col,
  Collapse,
  Row,
  Spin,
  Typography,
  Popconfirm,
  message,
  Space,
} from 'antd';
import {DeleteOutlined} from '@ant-design/icons';
import {Question, Test} from '../../graphql/API';
import type {QuestionWithNewFields} from '../Questions/QuestionTypes';
import {TestsService} from './TestsService';
import {QuestionsService} from '../Questions/QuestionsService';
import {getFileUrlByKey} from '../../utils';
import {QuestionModal} from './QuestionModal';
const testsService = new TestsService();
const questionsService = new QuestionsService();

export const TestDetails = () => {
  // 4fe2f51f-302e-40d1-ad9a-5d28d8e3fd69
  const [test, setTest] = useState<Test | undefined>(undefined);
  const [detailedQuestions, setDetailedQuestions] = useState<any[]>([]);
  const [isError, setIsError] = useState<boolean>(false);
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [isQuestionModalOpen, setIsQuestionModalOpen] = useState(false);
  const [selectedQuestion, setSelectedQuestion] =
    useState<QuestionWithNewFields>();
  let params: {testId: string} = useParams();
  const history = useHistory();

  const {Title, Text} = Typography;
  const {Panel} = Collapse;
  useEffect(() => {
    testsService
      .getTestById(params.testId)
      .then(async resp => {
        console.log('📋 Test/Daily Exercise response:', resp);
        console.log('📋 Questions from response:', resp?.questions);
        setTest(resp);

        // Check if questions exist and what structure they have
        if (resp?.questions && resp.questions.length > 0) {
          console.log('📋 Number of questions:', resp.questions.length);
          console.log('📋 First question structure:', resp.questions[0]);

          // Check if questions are already populated with data or just IDs
          const firstQuestion = resp.questions[0];
          const isPopulated =
            firstQuestion &&
            typeof firstQuestion === 'object' &&
            (firstQuestion.questionText ||
              firstQuestion.text ||
              firstQuestion.name);

          console.log('📋 Questions are populated:', isPopulated);

          if (isPopulated) {
            // Questions are already populated, use them directly
            console.log('✅ Using populated questions directly');
            setDetailedQuestions(resp.questions);
          } else {
            // Questions might be just IDs or references, fetch detailed data
            console.log('🔍 Fetching detailed question data...');
            const questionPromises = resp.questions.map((q: any) => {
              // Handle different possible structures
              const questionId = typeof q === 'string' ? q : q?._id || q?.id;
              console.log('🔍 Fetching question ID:', questionId);
              return questionId
                ? questionsService.getQuestionById(questionId)
                : Promise.resolve(null);
            });

            try {
              const detailedQuestionsData = await Promise.all(questionPromises);
              const validQuestions = detailedQuestionsData.filter(
                q => q !== null,
              );
              console.log(
                '✅ Fetched detailed questions:',
                validQuestions.length,
              );
              setDetailedQuestions(validQuestions);
            } catch (error) {
              console.error('❌ Error fetching detailed questions:', error);
              // Fallback: try to use whatever question data we have
              setDetailedQuestions(resp.questions);
            }
          }
        } else {
          console.log('📋 No questions in response');
          setDetailedQuestions([]);
        }

        setIsLoading(false);
      })
      .catch(error => {
        console.log('❌ Error fetching test:', error);
        setIsLoading(false);
        setIsError(true);
      });
  }, []);

  const handleDeleteTest = async () => {
    try {
      setIsLoading(true);
      await testsService.deleteTest(params.testId);
      message.success('Daily exercise deleted successfully');
      history.push('/tests');
    } catch (error) {
      message.error('Failed to delete daily exercise');
      console.error('Delete error:', error);
      setIsLoading(false);
    }
  };

  return (
    <div style={{padding: 10}}>
      <Title style={{textAlign: 'center'}}>Test </Title>
      <Space style={{float: 'right'}}>
        <Button size={'large'}>
          <Link
            // @ts-ignore
            to={{
              pathname: '/test/' + test?.id + '/edit',
              state: {test: test},
            }}>
            Edit
          </Link>
        </Button>
        {/* <Popconfirm
          title="Are you sure you want to delete this daily exercise?"
          okText="Yes"
          cancelText="No"
          onConfirm={handleDeleteTest}>
          <Button size={'large'} danger icon={<DeleteOutlined />}>
            Delete
          </Button>
        </Popconfirm> */}
      </Space>
      {!isError && !isLoading && (
        <div style={{margin: '20px'}}>
          <Text style={{display: 'block'}} strong={true}>
            Created at
          </Text>
          <Text>{test?.createdAt}</Text>

          <Text style={{display: 'block'}}>
            <Text style={{fontWeight: 'bold'}}>Description:</Text>
            {test?.description}
          </Text>
          <Text style={{display: 'block'}}>
            <Text style={{fontWeight: 'bold'}}>Summary:</Text> {test?.summary}
          </Text>

          <a
            target="_blank"
            rel="noopener noreferrer"
            style={{display: 'block'}}
            onClickCapture={async () => {
              if (test?.asset?.thumbnailUri) {
                const splitters =
                  test?.asset?.thumbnailUri.split('.pikado.io/');
                console.log('SDDSDDS', splitters[1]);

                const path = await getFileUrlByKey(splitters[1]);
                // window.open(path.url.toJSON());
                console.log('SDDSDDS11', path.url.toJSON());

                window.open(path.url.toJSON(), '_blank');
              }
            }}
            // href={test?.asset?.thumbnailUri!}
          >
            Thumbnail url
          </a>
          <a
            target="_blank"
            rel="noopener noreferrer"
            style={{display: 'block'}}
            onClickCapture={async () => {
              if (test?.asset?.fileUri) {
                const splitters = test?.asset?.fileUri.split('.pikado.io/');
                console.log('SDDSDDS', splitters[1]);

                const path = await getFileUrlByKey(splitters[1]);
                window.open(path.url.toJSON());
              }
            }}
            // href={test?.asset?.fileUri!}
          >
            Content url
          </a>
          <Title level={4} style={{marginTop: 20}}>
            Questions ({detailedQuestions.length})
          </Title>
          {detailedQuestions.length === 0 ? (
            <Text>No questions found for this daily exercise.</Text>
          ) : (
            <Collapse defaultActiveKey={['1']}>
              {detailedQuestions.map((question: any, index: number) => {
                return (
                  <Panel
                    key={question?.id || question?._id || index}
                    header={
                      'Question ' +
                      (index + 1) +
                      ': ' +
                      (question?.name || 'Unnamed Question')
                    }>
                    {question?.name && (
                      <Text style={{display: 'block'}}>
                        <Text style={{fontWeight: 'bold'}}>Name: </Text>
                        {question?.name}
                      </Text>
                    )}
                    {(question?.questionText || question?.text) && (
                      <Text style={{display: 'block'}}>
                        <Text style={{fontWeight: 'bold'}}>
                          Question Text:{' '}
                        </Text>
                        {question?.questionText || question?.text}
                      </Text>
                    )}
                    {(question?.AiText || question?.textAI) && (
                      <Text style={{display: 'block'}}>
                        <Text style={{fontWeight: 'bold'}}>AI Text: </Text>
                        {question?.AiText || question?.textAI}
                      </Text>
                    )}
                    {question?.type && (
                      <Text style={{display: 'block'}}>
                        <Text style={{fontWeight: 'bold'}}>Type: </Text>
                        {question?.type}
                      </Text>
                    )}
                    {question?.difficulty && (
                      <Text style={{display: 'block'}}>
                        <Text style={{fontWeight: 'bold'}}>Difficulty: </Text>
                        {question?.difficulty}
                      </Text>
                    )}
                    {question?.summary && (
                      <Text style={{display: 'block'}}>
                        <Text style={{fontWeight: 'bold'}}>Summary: </Text>
                        {question?.summary}
                      </Text>
                    )}
                    {question?.description && (
                      <Text style={{display: 'block'}}>
                        <Text style={{fontWeight: 'bold'}}>Description: </Text>
                        {question?.description}
                      </Text>
                    )}
                    {question?.payload && (
                      <Text style={{display: 'block'}}>
                        <Text style={{fontWeight: 'bold'}}>Payload: </Text>
                        <pre
                          style={{
                            whiteSpace: 'pre-wrap',
                            wordBreak: 'break-word',
                          }}>
                          {JSON.stringify(question?.payload, null, 2)}
                        </pre>
                      </Text>
                    )}
                    {question?.createdAt && (
                      <Text style={{display: 'block'}}>
                        <Text style={{fontWeight: 'bold'}}>Created At: </Text>
                        {question?.createdAt}
                      </Text>
                    )}
                    {question?.updatedAt && (
                      <Text style={{display: 'block'}}>
                        <Text style={{fontWeight: 'bold'}}>Updated At: </Text>
                        {question?.updatedAt}
                      </Text>
                    )}

                    <button
                      onClick={() => {
                        setIsQuestionModalOpen(!isQuestionModalOpen);
                        setSelectedQuestion(question);
                      }}>
                      View
                    </button>
                  </Panel>
                );
              })}
            </Collapse>
          )}
        </div>
      )}
      {isQuestionModalOpen && (
        <QuestionModal
          question={selectedQuestion}
          closeModal={() => setIsQuestionModalOpen(false)}
        />
      )}

      {isLoading && (
        <Spin size="large" style={{margin: 'auto', width: '100%'}} />
      )}
      {isError && <Title>Test fetching error ⚠️</Title>}
    </div>
  );
};
